import RestClient from './RestClient';
import { Group } from '../models';

class Groups extends RestClient {
    constructor() {
        super({
            // rest config
            model: Group,
            entryPoint: 'groups',
            id_field: '_id',
            // redux config
            resource: 'group',
            resources: 'groups',
        });
    }

    patchLanguage(id: string, notificationLanguage: string | null) {
        return this.patchGroup(id, { notificationLanguage });
    }

    patchGroup(id: string, patch: {
        notificationLanguage?: string | null;
        defaultProject?: string | null;
        defaultClient?: string | null;
    }) {
        return this.PATCH(`/${this.entryPoint}/${id}`, patch)
            .then(response => response.json())
            .then(json => {
                if (json.group)
                    return { group: new this.model(json.group) };
                throw new Error(json.err || json.error || '');
            });
    }

    syncGroups() {
        return this.POST(`/${this.entryPoint}/sync`, {})
            .then(response => response.json())
            .then(json => {
                if (Array.isArray(json.groups))
                    return {
                        groups: json.groups.map((row: AnyObj) => new this.model(row)),
                    };
                throw new Error(json.err || json.error || '');
            });
    }
};
const GroupsApi = new Groups();

export default GroupsApi;
